<style src='@/resources/styles/results.css' scoped></style>
<style src='@/resources/styles/results-animations.css' scoped></style>
<style src='@/resources/styles/results-synonyms.css' scoped></style>


<template>
  <main class='view-results'>
    <div class='inner'>
     <Overlay
      v-show="showOverlay"
      v-bind:text="overlayText"/>
      <section class='what-came-up'>
        <h1 class='lead'>
          Here's what I came up with for

          <!-- Read only divs -->
          <span class='words' v-if="! isEditing">
            <span v-for="(word, index) in seeds" v-bind:key="index" class="word">{{ word }}</span>
          </span>

          <!-- Editing divs -->

          <span class='words editable'
                v-show="isEditing"
                contenteditable="true"
                ref="editBox"
                @keydown.enter="editKeywords()"
                @keydown.enter.prevent>{{ seedsStr }}</span>



          <div>
            <button class='edit-button xl' @click="enableEdit()" v-if="! isEditing">Edit</button>
            <button class='edit-button xl' v-if="isEditing" @click="editKeywords()" >Update</button>
          </div>
        </h1>
      </section>


        <section class='what-came-up' v-if="suggestions.length > 0">
            <h1 class='lead synonym_lead' style="font-size: 21px;">
                Related:
                <span class='words'>
                  <a v-for="(word, index) in suggestions"
                     v-bind:key="index"
                     v-bind:href="suggestionUrl(word)"
                     target="_blank"
                     class="word synonym" >{{ word }}</a>
              </span>

            </h1>
        </section>
    </div>
      
    <section class='total-word-results'>
      <div class='inner'>
        <span class='matches'>
           <span class='matches-label'>{{proj.results.length}} / {{proj.total}} matches with</span>
          <button class='button-matches'
                v-on:click="showLiked"
                v-bind:class="{on: isShowingLiked}">{{likedCount}}</button> <span class='icon simple-smile'></span>
          <button
                  class='button-matches'
                v-on:click="showLoved"
                v-bind:class="{on: isShowingLoved}">{{lovedCount}}</button> <span class='icon grin-hearts'></span> <span class='matches-label'> &</span>
          <button class='button-matches'
                v-on:click="showDisliked"
                v-bind:class="{on: isShowingDisliked}">{{dislikedCount}}</button> <span class='icon thumbs-down'></span>
        </span>
              
        <div class='copy-results'>
          Share:
          <input class='field'  ref="url" style="min-width: 20%"
                 v-bind:value="url" onclick="this.select()">
          <button class='copier' v-on:click="copyUrl">
            <span class='label' ref="copyLabel">Copy URL</span>
            <span class='copy-icon'></span>
          </button>
        </div>
      </div>
    </section>
    
    <div class='inner'>
      <div class='loader'>
        <section class='word-results'>
            <transition-group appear name="results-list">
                <Result v-for="word in results"
                        v-bind:key="word.id"
                        v-bind:output="word"
                        v-bind:cls="word.cls"
                        @vote="onVote" />
            </transition-group>

            <InfiniteScroll text="Loading.." v-bind:is-busy="isLoading" v-bind:loader="loadMore" />
        </section>
      </div>

      <div class='go-again'>
        <br />


        <!-- view previous set
        <button 
          class='form-button previous-set'
           >
          View Batch
        </button>-->

        <!-- generate next set
        <button 
          class='form-button generate-set disabled'
          disabled="disabled"
          v-on:click="regen">
          Generate Batch {{nextBatchNumber}}
          <span class='icon-32x32 icon magic-wand'></span>
        </button>
        <div class='generate-set-info hide'>Please like, or love 2 words.</div> 
        -->
        
        <!-- load more
        <button 
          class='form-button load-more load-set'
          v-if="proj.hasMore"
          v-on:click="loadMore">
          Load More
        </button>-->
      </div>
      
      <section class='filters'>
        <!--
        <div class='quality-filter filter'>
          <span class='caption'>
            Variation Level <span class='help-mark'></span>
          </span>
          <div class='labels'>
            <span class='label label-start'>low</span>
            <span class='label label-middle'>medium</span>
            <span class='label label-end'>high</span>
          </div>
          <input type='range' min='1' max='100' v-model="variation"
                 v-on:change="variationChanged"
                 ref="variationSlider" />
        </div>
        <div class='length-filter filter'>
          <span class='caption'>
            Length <span class='help-mark'></span>I
          </span>
          <div class='labels'>
            <span class='label label-start'>short</span>
            <span class='label label-middle'>medium</span>
            <span class='label label-end'>long</span>
          </div>
          <input type='range' min='1' max='100' v-model="len"
          v-on:change="lenChanged"
                 ref="lenSlider" />
        </div>

        <KeywordFilter />
        <WordTypeFilter />
-->

      </section>
      
      <HealthBar ref="health" />
    </div>



  </main>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import Result from '../extended/Result.vue'
  import Overlay from "../extended/Overlay";
  import KeywordFilter from "../modules/filters/KeywordFilter"
  import WordTypeFilter from "../modules/filters/WordTypeFilter"
  import States from "../../States"
  import Vote from "../../Vote";
  import InfiniteScroll from "../extended/InfiniteScroll";
  import HealthBar from "../modules/payment/HealthBar";
  import WhenInViewPort from 'when-in-viewport'


  export default {
    name: 'ResultsView',

    mounted() {

      const slug = this.$route.params['slug'];
      const storeSlug = this.$store.getters.proj.slug;

      if (slug !== storeSlug) {
        window.console.log(`Fetching results again, slug: ${slug} / ${storeSlug}`);

        this.$router.push({path: `/loading/${slug}`});
        return;
      }

      this.$store.commit("setState", States.VIEWING);
      this.pageLoaded(this.$route);
    },

    components: {
      InfiniteScroll,
      Overlay,
      KeywordFilter,
      WordTypeFilter,
      Result,
      HealthBar
    },

    data: function () {
      return {
        isEditing: false,
        slug: this.$route.params['slug'],
        vote: null,
        overlayText: "",
        showOverlay: false,
        isLoading: false,
      }
    },

    computed: {
      ...mapGetters(["proj", "isFiltering", 'filters', 'page', 'state', "loadingStatus", "loadingProgress",
                    "currentVote", "ws", "suggestions", "credits"]),

      url() {
        return "https://naminus.com/results/" + this.proj.slug ;
      },


      seeds: function() {
        return this.$store.getters.proj.seeds;
      },

      seedsStr: function () {
        return this.$store.getters.proj.seeds.map(w => w.trim()).join(", ")
      },

      likedCount() {
        return this.proj.liked;
      },


      lovedCount() {
        return this.proj.loved;
      },

      dislikedCount() {
        return this.proj.disliked;
      },

      results () {
        const results = this.proj.results;
        const classes = ["purple", "blue", "gray"];
        let lastIndex = -1;
        const maxIndex = 2;

        for (let i = 0; i < results.length; i++) {
          if (results[i].gif) //skip gifs
            continue;

          let nextIndex = lastIndex + 1;
          if (nextIndex > maxIndex)
            nextIndex = 0;

          results[i].cls = classes[nextIndex];
          lastIndex = nextIndex;
        }

        return results;
      },

      isShowingLiked() {
          return this.currentVote === Vote.LIKED;
      },


      isShowingLoved() {
        return this.currentVote === Vote.LOVED;
      },

      isShowingDisliked() {
            return this.currentVote === Vote.DISLIKED;
      },


      suggestionUrl() {
        return (suggestion) => "/keyword/" + suggestion
      },
    },

    methods: {
      ...mapMutations(['setPage', 'setFiltering', 'setVote' ,'resetVotes', 'addResults', 'setError', 'removeError',
                      'setCredits']),
      ...mapActions(['filter', 'expectRegen', 'pageLoaded']),


      loadMore() {
        //Might be called even if redirected away to loading
        if (! this.filters.slug)
          return;

        this.$refs.health.noFlash();
        this.isLoading = true;
        window.console.log("PAGE:", this.filters.page);
        this.setPage(this.filters.page + 1);
        window.console.log("LOADING MORE", this.filters.page);
        //this.overlayText = "Loading More..";
        //this.showOverlay = true;
        this.filter( {filters: this.filters}, "" )
                .then(data => {
                  WhenInViewPort.checkAll(); //trigger resize, otherwise loadMore keeps getting hit with every scroll
                  this.showOverlay = false;
                  this.isLoading = false;

                  window.console.log("credits: ", this.credits);
                  if (this.credits.remaining <= 0)
                    this.$refs.health.flash();
                });
      },

      copyUrl() {
        this.$refs.url.select();
        this.$refs.url.setAttribute('type', 'text');
        this.$refs.copyLabel.textContent = "Copied!";
        document.execCommand("copy")
      },


        filterByVote(vote) {
          this.isLoading = true;

            if (vote !== this.currentVote)
              this.setVote(vote);
            else
              this.resetVotes();

            const payload = {filters: this.filters, clearExisting: true};
            this.overlayText = "Loading results..";
            this.showOverlay = true;
            this.setPage(1);
            this.filterAndScroll(payload);
        },

        showLoved() {
            this.filterByVote(Vote.LOVED);
        },

        showLiked() {
            this.filterByVote(Vote.LIKED);
        },

        showDisliked() {
            this.filterByVote(Vote.DISLIKED);
        },

        filterAndScroll(payload, scroll) {
          this.isLoading = true;
          //const oldWordIds = this.proj.results.map(w => w.id);
          //window.console.log("Old word ids: ", oldWordIds);
          this.filter( payload, "" )
            .then(data => {
                    this.showOverlay = false;
                    //In case of load more, don't scroll
                    if (scroll === false)
                      return;

                    const firstNewWord = data.results.find(w => w.vote === Vote.NEUTRAL);
                    window.console.log("First new word:", firstNewWord);
                    if (firstNewWord) {
                      const el = document.getElementById(`word_${firstNewWord.id}`);
                      window.console.log("Jumping to ", el);
                      this.$scrollTo(el, 500, {easing: "ease", offset: -50} );
                    }
                    this.isLoading = false;
                  });
        },

        onVote(newVote, word) {
          this.isLoading = true;
          //If current vote is the same as newVote, this is probably an attempt to clear the vote rather than
          //send a different vote

          const actualNewVote = (word.vote !== newVote) ? newVote : Vote.NEUTRAL;
          window.console.log("Voting ", actualNewVote, " on ", word);

          this.$refs.health.noFlash();
          const creditsBeforeVote = this.credits.remaining;
          if (creditsBeforeVote > 0) { //only show overlay if credits > 0
            this.overlayText = "Voting..";
            this.showOverlay = true;
          }

          this.ws.socketPromise.then(socket => {
            socket.vote(word.id, actualNewVote).then(result => {

              this.setCredits(result);


              if (result.regen === true)
                this.prepare4Regen(creditsBeforeVote);
              else {
                this.showOverlay = false;
                this.isLoading = false;
                if (this.credits.remaining <= 0)
                  this.$refs.health.flash();
              }
            })
          });
        },

      prepare4Regen(creditsBeforeVote) {

        window.console.log("Prepping 4 regen - proj id: ", this.proj.id);
        this.overlayText = "0.0%";
        const that = this;
        const payload = {
          projectId: this.proj.id,
          onProgress: function() {
            that.overlayText = that.loadingProgress;
          },

          onFinished: function () {
            window.console.log("Regen finished!!");
            that.overlayText = "Loading..";

            //Remove loadingProgress + status so they won't show up next time overlay is shown
            that.$store.commit("setLoadingProgress", "");
            that.$store.commit("setLoadingStatus", "");

            that.loadMore();
            if (creditsBeforeVote === 1 && this.credits.remaining <= 0) {
              const flashIfFinishedLoading = function() {
                if (this.isLoading) {
                  window.console.log("Still loading, not flashing");
                  setTimeout(flashIfFinishedLoading, 300);
                } else {
                  this.$refs.health.flash();
                }
              };

              flashIfFinishedLoading();
            }
          }
        };

        this.expectRegen(payload)
      },

      enableEdit() {
        this.isEditing = true;
        //editBox should be v-show, not v-if, or it can be inaccessible when we try to access it here

        //Use timeout so box is already visible before we try to focus
        setTimeout(() => {
          this.$refs.editBox.focus();
          //Set cursor to the end. Black magic courtesy of https://stackoverflow.com/questions/6249095/how-to-set-caretcursor-position-in-contenteditable-element-div
          const range = document.createRange();
          const sel = window.getSelection();
          range.setStart(this.$refs.editBox, 1);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);

        }, 100)
      },


      removeInvalidChars(seedsStr) {
        //If doesn't contain any invalid chars, skip without replacing
        if (/^[a-zA-Z, ]+$/i.test(seedsStr))
          return seedsStr;

        return seedsStr.replace(/[^a-zA-Z, ]+/ig, '').trim();
      },

      validateKeywords(words) {
        if (words.length > 3) {
          //const extra = words.length - 4;
          this.setError("Please enter 3 or fewer words (you entered " + words.length + ")");
          return false;
        }

        let error = null;
        const minLen = this.$store.getters.minLen;
        const maxLen = this.$store.getters.maxLen;

        for (let i = 0; i < words.length; i++) {
          const word = words[i];
          if (word.length < minLen) {
              error = word + " is too short - Please enter at least " + minLen + "  character words.";
              break;
          }
          else if (word.length > maxLen) {
            const extra = word.length - maxLen;
            error = word + " is too long - needs " + extra + " less character(s).";
            break;
          }
        }

        if (error === null) {
          this.removeError();
          return true;
        }


        this.setError(error);
        return false;
      },

      editKeywords() {
        const newSeedsStr = this.removeInvalidChars( this.$refs.editBox.textContent.trim() );
        if (newSeedsStr === this.seedsStr || newSeedsStr === "") {
          //nothing changed
          this.isEditing = false;
          return;
        }

        const seeds = newSeedsStr.split(",");
        window.console.log("Generating, seeds:", seeds);

        if (! this.validateKeywords(seeds))
          return;

        const payload = {
          keywords: seeds,
          router: this.$router,
        };

        this.$store.dispatch("generate", payload);
      }
    }
  }
</script>